import React from "react";
import CcButton from "../../../CoilConfigurator/components/CcButton";
import OpStatusPill from "../../components/OpStatusPill";
import type { EquipmentConfiguration } from "../../models/types";

interface InductionCoilCardProps {
  equipment: EquipmentConfiguration;
  onViewDetails: () => void;
}

const InductionCoilCard = ({ equipment, onViewDetails }: InductionCoilCardProps) => {
  const requiredCount = equipment.features.filter((f) => f.required && f.selected).length;
  const optionCount = equipment.options.filter((o) => o.status === "Selected").length;

  return (
    <article className="op-equip-card">
      <header className="op-equip-card__head">
        <div>
          <p className="op-equip-card__kicker">Induction Coil</p>
          <h3 className="op-equip-card__title">{equipment.configurationId}</h3>
        </div>
        <OpStatusPill status={equipment.status} />
      </header>
      <dl className="op-equip-card__meta">
        <div>
          <dt>Diameter Category</dt>
          <dd>{equipment.diameterCategory}</dd>
        </div>
        <div>
          <dt>Features</dt>
          <dd>{requiredCount}</dd>
        </div>
        <div>
          <dt>Options</dt>
          <dd>{optionCount}</dd>
        </div>
      </dl>
      <ul className="op-feature-list">
        {equipment.features
          .filter((f) => f.selected)
          .map((feature) => (
            <li key={feature.name}>
              ✓ {feature.name}
            </li>
          ))}
      </ul>
      <CcButton variant="secondary" onClick={onViewDetails}>
        View Details
      </CcButton>
    </article>
  );
};

export default InductionCoilCard;
